module.exports = __webpack_public_path__ + "media/images/lp_step3-607ee9a5497cef6d95c60ffd11e974ae.webp";